export default "__VITE_ASSET__BenexIYO__"